// 问卷调查
export default [
  {
    path: '/questionnaire/query',
    component: resolve => require(['@/pages/questionnaire/query.vue'], resolve),
    name: 'query',
    meta: {
      keepAlive: true,
      title: '返校统计',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/backSchoolReport',
    component: resolve => require(['@/pages/questionnaire/backSchoolReport.vue'], resolve),
    name: 'backSchoolReport',
    meta: {
      keepAlive: true,
      title: '返校统计报表',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/enter-check-query',
    component: resolve => require(['@/pages/questionnaire/enter-check-query.vue'], resolve),
    name: 'enter-check-query',
    meta: {
      keepAlive: true,
      title: '2021年秋季入校通行查询',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/enter-check-query-3',
    component: resolve => require(['@/pages/questionnaire/enter-check-query-3.vue'], resolve),
    name: 'enter-check-query-3',
    meta: {
      keepAlive: true,
      title: '2022年春季入校通行查询',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/query-2022',
    component: resolve => require(['@/pages/questionnaire/query-2022.vue'], resolve),
    name: 'query-2022',
    meta: {
      keepAlive: true,
      title: '2022年春季学生返校信息',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/health-trip-clock',
    component: resolve => require(['@/pages/questionnaire/health-trip-clock.vue'], resolve),
    name: 'health-trip-clock',
    meta: {
      keepAlive: true,
      title: '辅导员健康行程打卡',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/nucleic-acid-scan',
    component: resolve => require(['@/pages/questionnaire/nucleic-acid-scan.vue'], resolve),
    name: 'nucleic-acid-scan',
    meta: {
      keepAlive: true,
      title: '核酸检测登记',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/enter-check',
    component: resolve => require(['@/pages/questionnaire/enter-check.vue'], resolve),
    name: 'enter-check',
    meta: {
      keepAlive: true,
      title: '入校通行核对',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/enter-check-query2',
    component: resolve => require(['@/pages/questionnaire/enter-check-query2.vue'], resolve),
    name: 'enter-check-query2',
    meta: {
      keepAlive: true,
      title: '入校通行核对',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/sas-query',
    component: resolve => require(['@/pages/questionnaire/sas-query.vue'], resolve),
    name: 'sas-query',
    meta: {
      keepAlive: true,
      title: '焦虑自评量表',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/sds-query',
    component: resolve => require(['@/pages/questionnaire/sds-query.vue'], resolve),
    name: 'sds-query',
    meta: {
      keepAlive: true,
      title: '抑郁自评量表',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/upi-query',
    component: resolve => require(['@/pages/questionnaire/upi-query.vue'], resolve),
    name: 'upi-query',
    meta: {
      keepAlive: true,
      title: '大学生心理健康调查问卷（UPI）',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/scl-query',
    component: resolve => require(['@/pages/questionnaire/scl-query.vue'], resolve),
    name: 'scl-query',
    meta: {
      keepAlive: true,
      title: '症状自评量表（SCL－90）',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/sas-queryHistory',
    component: resolve => require(['@/pages/questionnaire/sas-queryHistory.vue'], resolve),
    name: 'sas-queryHistory',
    meta: {
      keepAlive: true,
      title: '查看历史',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/sds-queryHistory',
    component: resolve => require(['@/pages/questionnaire/sds-queryHistory.vue'], resolve),
    name: 'sds-queryHistory',
    meta: {
      keepAlive: true,
      title: '查看历史',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/scl-queryHistory',
    component: resolve => require(['@/pages/questionnaire/scl-queryHistory.vue'], resolve),
    name: 'scl-queryHistory',
    meta: {
      keepAlive: true,
      title: '查看历史',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/upi-queryHistory',
    component: resolve => require(['@/pages/questionnaire/upi-queryHistory.vue'], resolve),
    name: 'upi-queryHistory',
    meta: {
      keepAlive: true,
      title: '查看历史',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/return2018',
    component: resolve => require(['@/pages/questionnaire/return2018.vue'], resolve),
    name: 'return2018',
    meta: {
      keepAlive: true,
      title: '2018届返校统计',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/vaccine',
    component: resolve => require(['@/pages/questionnaire/vaccine-query.vue'], resolve),
    name: 'vaccine-query',
    meta: {
      keepAlive: true,
      title: '疫苗接种情况',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/facial',
    component: resolve => require(['@/pages/questionnaire/facial-information.vue'], resolve),
    name: 'facial-information',
    meta: {
      keepAlive: true,
      title: '人脸信息',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/self-study-card',
    component: resolve => require(['@/pages/questionnaire/self-study-card.vue'], resolve),
    name: 'self-study-card',
    meta: {
      keepAlive: true,
      title: '自习证',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/stay-in-card',
    component: resolve => require(['@/pages/questionnaire/stay-in-card.vue'], resolve),
    name: 'stay-in-card',
    meta: {
      keepAlive: true,
      title: '留校资格证',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/nucleic-statistics',
    component: resolve => require(['@/pages/questionnaire/nucleic-statistics.vue'], resolve),
    name: 'nucleic-statistics',
    meta: {
      keepAlive: true,
      title: '核酸检测统计',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/questionnaire/query-2022-spring',
    component: resolve => require(['@/pages/questionnaire/query-2022-spring.vue'], resolve),
    name: 'query-2022-spring',
    meta: {
      keepAlive: true,
      title: '5月返校统计',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/voteStatic',
    component: resolve => require(['@/pages/questionnaire/vote/voteStatic.vue'], resolve),
    name: 'voteStatic',
    meta: {
      keepAlive: true,
      title: '投票统计',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/sas-query-teacher',
    component: resolve => require(['@/pages/questionnaire/sas-query-teacher.vue'], resolve),
    name: 'sas-query-teacher',
    meta: {
      keepAlive: true,
      title: '自评量表',
      scollTopPosition: 0 // 滚动条位置
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/questionnaire.js